import { Component, computed, effect, inject, input, signal } from '@angular/core';

import {
  DmFiltersToApply,
  DmTableContext,
  DmTableOptions,
  RelationPropsType,
  ReloadDm,
} from '@module-instance/dynamic-module/common';
import { DocumentRelationsModel } from '@module-instance/dynamic-module/document-details/common/models/document-info.model';
import { DynamicModuleTableComponent } from '@module-instance/dynamic-module/dynamic-module-table/dynamic-module-table.component';
import { EntityTableRow } from '@shared/components/data-list/common';
import { PAGE_SIZE_OPTIONS } from '@shared/consts';
import { DocumentService } from '@shared/services/document.service';
import { UserStore } from '@signal-store/user.store';
import { DocumentDetailsStore } from '../../common';

@Component({
  selector: 'cipo-relations-tab',
  imports: [DynamicModuleTableComponent],
  templateUrl: './relations-tab.component.html',
})
export class RelationsTabComponent {
  private userStore = inject(UserStore);
  private documentService = inject(DocumentService);
  dmStore = inject(DocumentDetailsStore);

  relation = input<DocumentRelationsModel>();
  entityInstanceId = input<number>();
  currentDocument = computed(() => this.dmStore.documents()[this.entityInstanceId()]);

  relationProps = computed(
    () =>
      ({
        parentEntityInstanceId: this.currentDocument().params.entityInstanceId,
        relationId: this.relation().relationId,
        fieldId: this.relation().isNested ? this.relation().fieldId : undefined,
      }) as RelationPropsType,
  );
  filtersToApply = signal<DmFiltersToApply>({});
  reloadTable = signal<ReloadDm>(null);
  tableContext = computed<DmTableContext>(() => ({
    moduleId: this.relation().relatedModuleId,
    relationProps: this.relationProps(),
    workflowId: this.currentDocument().info.workflowId,
    contractId: this.currentDocument().params.contractId,
  }));

  private initialTableOptions: DmTableOptions = {
    clickableRows: true,
    serverPaginationSort: true,
    // we can't have infinite scroll without fixed height, so we'll have only paged list inside document tabs
    onlyPaged: true,
    pagination: {
      pageIndex: 0,
      pageSize: PAGE_SIZE_OPTIONS.default[2],
      pageSizeOptions: PAGE_SIZE_OPTIONS.default,
    },
    sort: {
      active: 'full_doc_num',
      direction: 'desc',
    },
  };
  private openedDocumentId: number = null;

  tableOptions = signal(this.initialTableOptions);

  constructor() {
    effect(() => {
      const entityInstanceId = this.userStore.dialogData();
      if (entityInstanceId && entityInstanceId === this.openedDocumentId) {
        this.openedDocumentId = null;
        this.reloadTable.set({ entityInstanceIds: [entityInstanceId] });
      }
    });
  }

  //   This is the only action that can be triggered from the relations data-list
  openDocument(row: EntityTableRow) {
    const dialogRef = this.documentService.openDocument({
      entityInstanceId: row.entity_instance_id,
      moduleId: row.module_id,
      contractId: row.contract_id,
      screenId: row.screen_id,
      workflowId: row.workflow_id,
    });
    if (!dialogRef) {
      return;
    }
    dialogRef.afterClosed().subscribe(() => this.reloadTable.set({ entityInstanceIds: [row.entity_instance_id] }));
  }
}
